// import * as Sentry from '@sentry/node';
// import { nodeProfilingIntegration } from '@sentry/profiling-node';

// Sentry.init({
//   dsn: process.env.SENTRY_DSN,
//   integrations: [nodeProfilingIntegration()],
//   // Performance Monitoring
//   tracesSampleRate: parseInt(process.env.SENTRY_TRACING_RATE), //  Capture 100% of the transactions

//   // Set sampling rate for profiling - this is relative to tracesSampleRate
//   profilesSampleRate: parseInt(process.env.SENTRY_PROFILING_RATE),
// });
